import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiGift, FiTrendingUp, FiCheck } = FiIcons;

const LeadCapture = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Here you would integrate with your email service
      console.log('Email submitted:', email);
      setIsSubscribed(true);
      setEmail('');
    }
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-r from-pink-600 to-purple-600">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center text-white"
        >
          <div className="mb-8">
            <SafeIcon icon={FiGift} className="text-6xl mx-auto mb-6 animate-bounce" />
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Get Exclusive Updates & Bonuses
            </h2>
            <p className="text-xl opacity-90 mb-8">
              Be the first to know about major announcements, airdrops, and exclusive opportunities. 
              Join 50,000+ PinkZilla insiders!
            </p>
          </div>

          {!isSubscribed ? (
            <motion.form
              onSubmit={handleSubmit}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-md mx-auto"
            >
              <div className="flex flex-col sm:flex-row gap-4 mb-6">
                <div className="flex-1 relative">
                  <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="w-full pl-10 pr-4 py-3 rounded-full text-gray-800 bg-white border-0 focus:ring-2 focus:ring-pink-300 focus:outline-none"
                    required
                  />
                </div>
                <motion.button
                  type="submit"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-yellow-400 text-gray-800 px-8 py-3 rounded-full font-bold hover:bg-yellow-300 transition-all whitespace-nowrap"
                >
                  Get Updates
                </motion.button>
              </div>
              
              <div className="text-sm opacity-80 mb-6">
                <p>🎁 Subscribers get exclusive access to:</p>
                <ul className="list-none mt-2 space-y-1">
                  <li>✨ Early airdrop notifications</li>
                  <li>🚀 Pre-announcement alpha</li>
                  <li>💎 VIP community access</li>
                  <li>🎯 Trading signals & tips</li>
                </ul>
              </div>
            </motion.form>
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiCheck} className="text-white text-2xl" />
              </div>
              <h3 className="text-2xl font-bold mb-2">Welcome to the PinkZilla Family!</h3>
              <p className="text-lg opacity-90">
                Check your email for exclusive updates and bonuses. Now let's get you some $PINKZILLA!
              </p>
            </motion.div>
          )}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-12"
          >
            <motion.a
              href="https://pump.fun/AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-pink-600 px-8 py-4 rounded-full font-bold text-lg inline-flex items-center space-x-2 shadow-2xl hover:shadow-3xl transition-all"
            >
              <SafeIcon icon={FiTrendingUp} />
              <span>Buy $PINKZILLA Now</span>
            </motion.a>
          </motion.div>

          <div className="mt-8 text-sm opacity-75">
            <p>🔒 We respect your privacy. No spam, unsubscribe anytime.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LeadCapture;